<script lang="ts">
  import { currentBootcamp } from "$lib/client/stores/nucamp-currentbootcamp";
  import * as Dialog from "$lib/components/ui/dialog";
  import type { Bootcamp } from "$lib/datamodel";
  
  export let open = false;
  export let openFollowBootcamp = false;
  export let onOpenChange: any;
  export let bootcamps: Bootcamp[];

  function selectBootcamp (bootcampId: string) {
    // console.log("bootcampId", bootcampId);
    const selBootcamp = bootcamps.find((bc) => bc.id === bootcampId) || null;
    currentBootcamp.set(selBootcamp);
    open = false;
    openFollowBootcamp = true;
  }
  function onKeyDown(event: KeyboardEvent, data: any) {
    if (event.key === "Enter" || event.key === " ") {
      selectBootcamp(data);
    }
  }
</script>
 
<Dialog.Root bind:open bind:onOpenChange>
  <Dialog.Content class="p-0 max-w-[90%] max-h-[90%] sm:max-w-[75%] lg:max-w-[50%] 2xl:max-w-[45%] bg-base-100 flex flex-col dark:border-slate-700">
    <Dialog.Header class="p-4 pb-2">
      <Dialog.Title><h3 class="text-2xl px-2 pr-6 md:text-3xl md:px-0 font-bold">Interested in a Bootcamp?</h3></Dialog.Title>
      <Dialog.Description>
        <p class="text-md md:text-lg">Click on the bootcamp you would like to learn more about.</p>
      </Dialog.Description>
    </Dialog.Header>
    <div class="p-4 flex-1 overflow-y-auto">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        {#each bootcamps as bootcamp}
          <div class="!outline-0 card card-side bg-slate-100 dark:bg-slate-700 dark:hover:bg-nucamp-{bootcamp.name} border border-nucamp-{bootcamp.name} hover:bg-nucamp-{bootcamp.name} hover:text-slate-100 shadow-nucamp-sm cursor-pointer hover:shadow-nucamp-md " role="button" tabindex="0" on:keydown={(event) => onKeyDown(event, bootcamp.id)} aria-label="Select a Bootcamp" on:click={() => selectBootcamp(bootcamp.id)}>
            <figure class="w-1/4">
              <img class="w-3/4" src={bootcamp.img} alt={bootcamp.title} />
            </figure>
            <div class="card-body p-4 w-3/4">
              <p class="text-md font-bold line-clamp-2">{bootcamp.title}</p>
              <p class="text-sm">{bootcamp.length}</p>
            </div>
          </div>
        {/each}
      </div>
    </div>
  <Dialog.Close></Dialog.Close>
  </Dialog.Content>
</Dialog.Root>